import { render, staticRenderFns } from "./wy-experience-and-automation-page.vue?vue&type=template&id=5837d6f4&"
import script from "./wy-experience-and-automation-page.vue?vue&type=script&lang=js&"
export * from "./wy-experience-and-automation-page.vue?vue&type=script&lang=js&"
import style0 from "./wy-experience-and-automation-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports